// @flow

import { useCallback, useEffect, useRef } from 'react';

import { type UserInputName } from '../user-input';
import { useUserInputValue } from './use-user-input-value';

type Value = string;
type TextFieldEvent = SyntheticInputEvent<HTMLInputElement | HTMLTextAreaElement>;
type HandleChange = (event: TextFieldEvent) => void;

export function useUserInputAsTextField(name: UserInputName): [Value, HandleChange] {
  const [value, setValue] = useUserInputValue(name);

  const handleChange = useCallback(
    (event: TextFieldEvent) => setValue(event.target.value),
    [setValue],
  );

  return [value, handleChange];
}

export function useUserInputAsTextFieldWithInitialValue(name: UserInputName, initialValue: Value): [Value, HandleChange] {
  const isFirstRender = useRef(true);
  const [value, setValue] = useUserInputValue(name);

  const handleChange = useCallback(
    (event: TextFieldEvent) => setValue(event.target.value),
    [setValue],
  );

  useEffect(() => {
    if (isFirstRender.current) {
      setValue(initialValue);
      isFirstRender.current = false;
    }
  }, [setValue]);

  return [value, handleChange];
}
